// Mocked map — converts lat/lng of points to relative positions inside a stylised grid.
// We anchor to the bounding box of the given points so pins always render in view.
import { useMemo, useState } from "react";

export const MapMock = ({ points = [], sites = [], height = 480, onPinClick }) => {
  const all = [...points.map(p => ({ lat: p.lat, lng: p.lng })),
                ...sites.map(s => ({ lat: s.lat, lng: s.lng }))];
  const bounds = useMemo(() => {
    if (!all.length) return { minLat: 6.4, maxLat: 6.6, minLng: 3.3, maxLng: 3.5 };
    const lats = all.map(a => a.lat), lngs = all.map(a => a.lng);
    const padLat = Math.max(0.005, (Math.max(...lats) - Math.min(...lats)) * 0.2);
    const padLng = Math.max(0.005, (Math.max(...lngs) - Math.min(...lngs)) * 0.2);
    return {
      minLat: Math.min(...lats) - padLat, maxLat: Math.max(...lats) + padLat,
      minLng: Math.min(...lngs) - padLng, maxLng: Math.max(...lngs) + padLng,
    };
  }, [all]);

  const pos = (lat, lng) => ({
    top: `${((bounds.maxLat - lat) / (bounds.maxLat - bounds.minLat)) * 100}%`,
    left: `${((lng - bounds.minLng) / (bounds.maxLng - bounds.minLng)) * 100}%`,
  });

  const [hover, setHover] = useState(null);

  return (
    <div className="map-mock" style={{ height }} data-testid="map-mock">
      {/* Geofence rings around sites */}
      {sites.map((s, i) => {
        const p = pos(s.lat, s.lng);
        const r = Math.max(40, Math.min(120, (s.geofence_radius_m || 200) / 3));
        return (
          <div key={`fence-${i}`} className="geofence-ring"
               style={{ top: p.top, left: p.left, width: r * 2, height: r * 2 }} />
        );
      })}
      {/* Pins */}
      {points.map((pt, i) => {
        const p = pos(pt.lat, pt.lng);
        return (
          <div
            key={`pin-${i}`}
            className={`map-pin ${pt.alert ? "alert" : ""}`}
            style={{ top: p.top, left: p.left }}
            onMouseEnter={() => setHover(pt)}
            onMouseLeave={() => setHover(null)}
            onClick={() => onPinClick && onPinClick(pt)}
            data-testid={`map-pin-${i}`}
          />
        );
      })}
      {hover && (
        <div style={{
          position: "absolute", top: 12, right: 12,
          background: "#0D1B2A", border: "1px solid #2A3A4A",
          padding: "10px 14px", borderRadius: 8, fontSize: 13, color: "#fff",
          maxWidth: 240,
        }}>
          <div style={{ color: "#2ECAC8", fontSize: 12, marginBottom: 4 }}>{hover.label}</div>
          <div className="text-muted" style={{ fontSize: 12 }}>{hover.sub}</div>
        </div>
      )}
      <div style={{
        position: "absolute", left: 12, bottom: 12,
        background: "rgba(13, 27, 42, 0.85)", padding: "6px 10px",
        borderRadius: 6, fontSize: 11, color: "#8CA0B8",
      }}>
        Live tracking · mocked map (Google Maps integration ready)
      </div>
    </div>
  );
};
